/** Mesmo teto do backend (`MAX_PUBLICAR_TAMBEM` em `noticia_meta.py`). */
export const MAX_PUBLICAR_TAMBEM = 5;

/**
 * Aceita a nova seleção só se ela couber no limite. Remover sempre passa,
 * mesmo quando o valor salvo já veio acima do teto.
 */
export const cabeNoLimite = (
  atual: string[],
  nova: string[],
  max: number = MAX_PUBLICAR_TAMBEM,
): boolean => nova.length <= max || nova.length < atual.length;
